

import axiosClient from "./axiosClient";
import store from "../app/store";

const adminApi = {
    getAllAdmin: () => {
        const url = `api/admin/get-all-admin`
        return axiosClient.get(url,{
            useAuthorize: true
        })
    },

    addAdmin: (data) => {
        const url = `api/admin/add-admin`
        return axiosClient.post(url, data,{
            useAuthorize: true
        })
    },

    updateAdmin: (param, data) => {
        const url = `api/admin/update-admin/${param}`
        return axiosClient.put(url, data,{
            useAuthorize: true
        })
    },

    getAdminById: (param) => {
        const url = `api/admin/get-admin-info/${param}`
        return axiosClient.get(url,{
            useAuthorize: true
        })
    },

    deleteAdmin: (param) => {
        const url = `api/admin/delete-admin/${param}`
        return axiosClient.delete(url,{
            useAuthorize: true
        })
    },
    // loginAdmin: async (data) => {
    //     const url = `api/admin/login-admin`
    //     const response = await axiosClient
    //         .post(url, data);
    //     if (response.data.accessToken) {
    //         localStorage.setItem("user", JSON.stringify(response.data));
    //     }
    //     return response.data;
    // },
      
}
const login = async (data) => {
    const url = `api/admin/login-admin`
    const response = await axiosClient
        .post(url, data);    
    return response.data;
}
const refreshToken = async (data) => {
    const url = `api/admin/refreshToken`
    const response = await axiosClient
        .post(url, data);    
    return response?.data;
}
const logout = async (token) => {
    const url = `api/admin/logout-admin`
    const response = await axiosClient
        .post(url, token,{
            useAuthorize: true
        });    
    return response?.data;
};
const getCurrentUser = () => {
    return store.getState().adminAuthen.user
  };
  
const AuthService = {
    login,
    logout,
    refreshToken,
    getCurrentUser
};
export default {AuthService, adminApi};